import React, { createContext, useContext, useState } from "react";

const TableUIContext = createContext();

export const useTableUI = () => useContext(TableUIContext);

export const TableUIProvider = ({ children }) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [collapsedRows, setCollapsedRows] = useState([]);

    return (
        <TableUIContext.Provider value={{
            selectedRows,
            setSelectedRows,
            collapsedRows,
            setCollapsedRows,
        }}>
            {children}
        </TableUIContext.Provider>
    );
};
